export default __webpack_public_path__ + "static/media/logo.06c5edcd.svg";